import dmcaData from '../../components/TermsOfService/dmcaData';
import LegalDocument from './LegalDocument';

const DmcaPage = () => (
  <LegalDocument
    data={dmcaData}
    relatedLinks={[
      { to: '/terms', label: 'Full Terms of Service' },
      { to: '/privacy', label: 'Privacy Policy' },
    ]}
  />
);

export default DmcaPage;
